function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
import { PhotoIcon } from '@domain-group/fe-co-icon';
import MultiResolutionImage from '@domain-group/fe-co-multi-resolution-image';
import { AllImageSizes, getImageUrl } from '@domain-group/fe-allhomes-library/lib/enums/image-size';
import AllhomesWatchlistButton from '@domain-group/fe-co-allhomes-watchlist-button';
import AllhomesListingCardMediaStats from './allhomes-listing-card-media-stats';
import * as styles from './allhomes-listing-card-images.style';
import { jsx as ___EmotionJSX } from "@emotion/core";
var AllhomesListingCardImages = _ref => {
  var className = _ref.className,
    firstImage = _ref.firstImage,
    alt = _ref.alt,
    children = _ref.children,
    anchorAttributes = _ref.anchorAttributes,
    appearance = _ref.appearance,
    listingId = _ref.listingId,
    _ref$has3dTour = _ref.has3dTour,
    has3dTour = _ref$has3dTour === void 0 ? false : _ref$has3dTour,
    _ref$hasVideo = _ref.hasVideo,
    hasVideo = _ref$hasVideo === void 0 ? false : _ref$hasVideo,
    _ref$numPhotos = _ref.numPhotos,
    numPhotos = _ref$numPhotos === void 0 ? 0 : _ref$numPhotos,
    _ref$onAddToWatchlist = _ref.onAddToWatchlist,
    onAddToWatchlist = _ref$onAddToWatchlist === void 0 ? () => {} : _ref$onAddToWatchlist,
    _ref$watchlistPopupAl = _ref.watchlistPopupAlignment,
    watchlistPopupAlignment = _ref$watchlistPopupAl === void 0 ? 'center' : _ref$watchlistPopupAl;
  var isVerticalCard = appearance === 'vertical';
  var hasMediaStats = Boolean(has3dTour || hasVideo || numPhotos);
  var isDefault = !firstImage;
  var imgClass = isVerticalCard ? styles.imgWide({
    isDefault,
    isVerticalCard
  }) : styles.imgSquare(isDefault);
  return ___EmotionJSX("div", _extends({
    css: styles.image({
      isDefault,
      appearance
    })
  }, anchorAttributes), children, ___EmotionJSX("div", {
    css: styles.watchlistButton
  }, ___EmotionJSX(AllhomesWatchlistButton, {
    inactiveColour: "white",
    listingId: listingId,
    onAddToWatchlist: onAddToWatchlist,
    popupAlignment: watchlistPopupAlignment,
    noText: true
  })), ___EmotionJSX("span", null, firstImage ? ___EmotionJSX(MultiResolutionImage, {
    css: imgClass,
    src: getImageUrl(firstImage, AllImageSizes.LARGE),
    alt: alt
  }) : ___EmotionJSX("div", {
    css: imgClass
  }, ___EmotionJSX("div", null, ___EmotionJSX(PhotoIcon, {
    size: "regular"
  })), ___EmotionJSX("div", {
    className: "".concat(className, "-img-text")
  }, "Image not available"))), hasMediaStats && ___EmotionJSX(AllhomesListingCardMediaStats, {
    has3dTour: has3dTour,
    hasVideo: hasVideo,
    numPhotos: numPhotos
  }));
};
export default AllhomesListingCardImages;